import uuidv4 from 'uuid/v4'

// Function to generate a uuidv4
// const uuidv4 = function () {
//   return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
//     (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
// }

export default uuidv4
